export function fromServerPayload(json) {
  const blocks = (json.blocks || []).map((block) => ({
    id: block.id,
    label: block.label,
    durationMs: Number(block.duration_ms) || 0
  }))

  return {
    blocks,
    currentIndex: json.current_index ?? 0,
    status: json.status ?? "idle",
    targetEndTime: json.target_end_time != null ? Number(json.target_end_time) : null,
    remainingMs: json.remaining_ms != null ? Number(json.remaining_ms) : null,
    segmentDurationMs: json.segment_duration_ms != null ? Number(json.segment_duration_ms) : null
  }
}

export function toServerPayload(snapshot) {
  return snapshot
}
